module.exports = __webpack_public_path__ + "img/tkb-logo.70f509a2.svg";